import { MailIcon } from '@heroicons/react/outline';
import { createBaseColumn } from '../../utils/columnUtils';
import { TableTemplate } from '../../types';

export const trackOutreachTemplate: TableTemplate = {
  id: 'track_outreach',
  name: 'Conversation Tracking',
  description: 'Track your outreach and conversation history with creators',
  icon: MailIcon,
  iconName: 'MailIcon',
  variant: 'gradient',
  defaultConfig: {
    columns: [
      createBaseColumn('invitation_sent', 'Invitation Sent?', {
        cell_type: 'communication',
        prompt: 'Has an invitation or outreach message been sent to this creator? Answer with one of: Yes (if we sent outreach), No (if no outreach sent yet)',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('last_message_date', 'Last Message Date', {
        cell_type: 'communication',
        prompt: 'When was the last message sent to this creator? Provide the date or "No messages sent yet"',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('response_status', 'Response Status', {
        cell_type: 'communication',
        prompt: 'What is the creator\'s response status? Answer with one of: No Response, Declined, Interested',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      }),
      createBaseColumn('next_action', 'Next Action', {
        cell_type: 'communication',
        prompt: 'Look at the most recent message in the email thread for this project. Who sent it and who is waiting for a response? Answer with one of: "Waiting on Creator" (if USER sent the last message), "Waiting on Us" (if CREATOR sent the last message), or "No Outreach Yet" (if no emails found for this project).',
        data_type: 'text',
        requires_thread: true,
        communication_sources: ['email_history', 'outlook_conversations'],
        email_provider: 'outlook'
      })
    ]
  }
};

